module.exports = __webpack_public_path__ + "static/media/arrow-white.e62f9d01.svg";